<div data-testid="step-1-1-company-information">
  <app-step-dot-menu
    [projectId]="projectId"
    testId="step1-1-dot-menu-button"
    [preselectedRole]="contributorRole"
    [preselectedAccessiblePages]="[companyInformationStep]"
  ></app-step-dot-menu>

  <p-tabs appTabsUnsavedReveal [(value)]="activeTab" data-testid="step-1-1-tabs" scrollable>
    <p-tablist data-testid="step-1-1-tablist">
      @for (tab of unitTabs(); track tab.office.id) {
        <p-tab
          [value]="tab.index"
          [appTabStatus]="tab.tabStatus"
          [attr.data-testid]="'office-tab-' + tab.index"
          [attr.data-unit-status]="tab.status"
        >
          <div class="flex flex-col gap-1 text-left">
            <span class="font-bold">{{ tab.office.name }}</span>
            <span class="text-muted-color text-sm">
              {{ countryService.getCountryNameByCode(tab.office.countryCode) }},
              {{ tab.office.cityName }}
            </span>
          </div>
        </p-tab>
      } @empty {
        <p-tab [value]="0" data-testid="empty-office-tab">
          {{ 'project.steps.noOffices' | transloco }}
        </p-tab>
      }

      <p-tab
        [value]="summaryTabValue()"
        [appTabStatus]="summaryTabStatus()"
        data-testid="summary-tab"
      >
        {{ 'project.steps.summary' | transloco }}
      </p-tab>
    </p-tablist>

    <p-tabpanels class="mt-6" data-testid="step-1-1-tabpanels">
      <p-card data-testid="step-1-1-card">
        @for (tab of unitTabs(); track tab.office.id) {
          <p-tabpanel [value]="tab.index" [attr.data-testid]="'office-tabpanel-' + tab.index">
            <app-company-unit-form
              [projectId]="projectId"
              [office]="tab.office"
              [savedValues]="tab.savedValues"
              [industryDropdown]="industryDropdown()"
              [tariffDropdown]="tariffDropdown()"
              [locked]="isCurrentStepLocked()"
              (valuesChange)="onUnitValuesChange(tab.office.id, $event)"
              (saved)="onUnitSaved($event)"
            />
            <app-audit-info [auditInfo]="auditInfo()" />
          </p-tabpanel>
        } @empty {
          <div class="p-4 text-center">{{ 'project.steps.noOfficePanels' | transloco }}</div>
        }

        <p-tabpanel [value]="summaryTabValue()" data-testid="summary-tabpanel">
          <app-company-summary [units]="unitSummaries()" />
        </p-tabpanel>
      </p-card>
    </p-tabpanels>
  </p-tabs>
</div>
